module.exports = __webpack_public_path__ + "img/horizontal-en.8955bce1.svg";